var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("呆账商品列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "row"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "180px",
                                      "line-height": "40px",
                                      "font-size": "14px",
                                      color: "#606266"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  搜索条件:\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商品货号" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.goods_no,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_no",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_no"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商品名称" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.goods_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "goods_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.goods_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "市场" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.market_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "market_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.market_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "商家" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.supply_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "supply_name",
                                                $$v
                                              )
                                            },
                                            expression: "form.supply_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              multiple: "",
                                              placeholder: "商家城市"
                                            },
                                            model: {
                                              value: _vm.form.city,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "city", $$v)
                                              },
                                              expression: "form.city"
                                            }
                                          },
                                          _vm._l(_vm.citys, function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "代采单" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.woid,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "woid", $$v)
                                            },
                                            expression: "form.woid"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "代采组" },
                                            model: {
                                              value: _vm.form.pgid,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "pgid", $$v)
                                              },
                                              expression: "form.pgid"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.pgOption,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    value: item.value,
                                                    label: item.label
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "订单负责人"
                                            },
                                            model: {
                                              value: _vm.form.order_owner,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "order_owner",
                                                  $$v
                                                )
                                              },
                                              expression: "form.order_owner"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.owner_option,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    value: item.value,
                                                    label: item.label
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "操作人" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.operator,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "operator",
                                                $$v
                                              )
                                            },
                                            expression: "form.operator"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "sku" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.form.sku,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "sku", $$v)
                                            },
                                            expression: "form.sku"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "欠货来源" },
                                            model: {
                                              value: _vm.form.source,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "source",
                                                  $$v
                                                )
                                              },
                                              expression: "form.source"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "全部"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                value: "100",
                                                label: "代采欠货"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                value: "1",
                                                label: "退换货欠货"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                value: "2",
                                                label: "售后欠货"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-option", {
                                              attrs: {
                                                value: "3",
                                                label: "售后退供"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "一级原因" },
                                            on: { change: _vm.setReson },
                                            model: {
                                              value: _vm.form.p_reason_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "p_reason_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.p_reason_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "一级原因"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.reasonOption,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.reason_id,
                                                  attrs: {
                                                    label: item.reason_name,
                                                    value: item.reason_id
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-select",
                                          {
                                            attrs: { placeholder: "二级原因" },
                                            model: {
                                              value: _vm.form.reason_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "reason_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.reason_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 0,
                                              attrs: {
                                                value: "0",
                                                label: "二级原因"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.subReasonOption,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.reason_id,
                                                  attrs: {
                                                    label: item.reason_name,
                                                    value: item.reason_id
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "次品组"
                                            },
                                            model: {
                                              value: _vm.form.dgid,
                                              callback: function($$v) {
                                                _vm.$set(_vm.form, "dgid", $$v)
                                              },
                                              expression: "form.dgid"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.dg_group,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "退换货负责人"
                                            },
                                            model: {
                                              value: _vm.form.dpc_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "dpc_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.dpc_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.option_dgm,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              filterable: "",
                                              placeholder: "售后退供员"
                                            },
                                            model: {
                                              value: _vm.form.refunder_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "refunder_id",
                                                  $$v
                                                )
                                              },
                                              expression: "form.refunder_id"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.resData.dgm_refunder,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "代采欠货标签"
                                            },
                                            model: {
                                              value: _vm.form.owe_label,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "owe_label",
                                                  $$v
                                                )
                                              },
                                              expression: "form.owe_label"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              attrs: {
                                                label: "全部",
                                                value: "0"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.oweLabelOptions,
                                              function(item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "扫码出库人" },
                                          nativeOn: {
                                            keyup: function($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              ) {
                                                return null
                                              }
                                              return _vm.search.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.form
                                                .stock_out_create_admin_str,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "stock_out_create_admin_str",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.stock_out_create_admin_str"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "订单生成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.wo_create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wo_create_time", $$v)
                                    },
                                    expression: "form.wo_create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "生成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.create_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "create_time", $$v)
                                    },
                                    expression: "form.create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "退换货生成时间" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.stock_out_create_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "stock_out_create_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.stock_out_create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "warning", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.debtTransferToOwe()
                      }
                    }
                  },
                  [_vm._v("\n          转欠货\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", size: "small" },
                    on: {
                      click: function($event) {
                        return _vm.transToBrokenDebts(false)
                      }
                    }
                  },
                  [_vm._v("\n          转坏账")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "small" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("\n          导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark",
                          "cell-class-name": _vm.addColor
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            type: "selection",
                            width: "55",
                            label: "选择"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_img",
                            label: "图片",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: {
                                            src: scope.row.main_img,
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3835964443
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "brand_name",
                            label: "品牌",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "货号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "woid",
                            label: "代采单"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "create_time",
                            label: "代采单生成时间"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "source",
                            label: "欠货来源"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", [_vm._v(_vm._s(row.source))]),
                                    _vm._v(" "),
                                    row.is_transit_formal
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "#006cff" } },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(row.is_transit_formal) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            527890616
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "market_name",
                            label: "市场",
                            width: "55"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_city",
                            label: "城市",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "pgname",
                            label: "代采组"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "order_owner_name",
                            label: "订单负责人"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dg_group_name",
                            label: "次品组",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dgm_name",
                            label: "退换货负责人",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refunder",
                            label: "售后退供员",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺码",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "sku",
                            label: "sku",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "代采单价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "p_reason_text",
                            label: "一级原因",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reson_text",
                            label: "二级原因",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "source",
                            label: "来源",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "remark",
                            label: "备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "application_name",
                            label: "操作人",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "application_time",
                            label: "生成时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_admin_str",
                            label: "扫码出库人",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "90"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_time",
                            label: "退换货生成时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "150"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, sizes, jumper",
                        total: _vm.resData.count,
                        "page-size": _vm.form.page_size,
                        "page-sizes": [50, 100]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": function(v) {
                          _vm.form.page_size = v
                          _vm.fetchData()
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            width: "30%",
            center: "",
            title: "提示",
            visible: _vm.outerVisible
          },
          on: {
            "update:visible": function($event) {
              _vm.outerVisible = $event
            }
          }
        },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                width: "50%",
                title: "重选原因",
                visible: _vm.innerVisible,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.innerVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { model: _vm.reloadReason } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "原因" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "一级原因" },
                          model: {
                            value: _vm.reloadReason.p_reasonId,
                            callback: function($$v) {
                              _vm.$set(_vm.reloadReason, "p_reasonId", $$v)
                            },
                            expression: "reloadReason.p_reasonId"
                          }
                        },
                        [
                          _c("el-option", {
                            key: 0,
                            attrs: { value: "0", label: "一级原因" }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.resData.reasonOption, function(item) {
                            return _c("el-option", {
                              key: item.reason_id,
                              attrs: {
                                label: item.reason_name,
                                value: item.reason_id
                              }
                            })
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "二级原因" },
                          model: {
                            value: _vm.reloadReason.reason_id,
                            callback: function($$v) {
                              _vm.$set(_vm.reloadReason, "reason_id", $$v)
                            },
                            expression: "reloadReason.reason_id"
                          }
                        },
                        [
                          _c("el-option", {
                            key: 0,
                            attrs: { value: "0", label: "二级原因" }
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.subReson, function(item) {
                            return _c("el-option", {
                              key: item.reason_id,
                              attrs: {
                                label: item.reason_name,
                                value: item.reason_id
                              }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.reloadReason.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.reloadReason, "remark", $$v)
                          },
                          expression: "reloadReason.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.hiddenReload()
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: {
                        click: function($event) {
                          return _vm.transToBrokenDebts(true)
                        }
                      }
                    },
                    [_vm._v("\n          确定")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("确定要转坏账吗?")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.outerVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = true
                    }
                  }
                },
                [_vm._v("\n        重选原因")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.transToBrokenDebts(true)
                    }
                  }
                },
                [_vm._v("\n        提交申请")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56567dab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56567dab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseStagnantDebts.vue
// module id = null
// module chunks = 